import interceptedAxios from '../../../utils/interceptedAxios'

interface LabelScores {
  scores: Record<string, number>
}
export interface Alarm {
  severity: string | null
  activeSince: string | null
  parameterName: string
  deviceName?: string
  status: string
}
export interface AlarmData {
  totalcount: number
  labelScores: LabelScores
  alarms: Alarm[] | null
}

export async function fetchEnabledAlarmsbyLabel (
  siteId: string, assetId: string, label: string, SortParams: string,
  onSuccess: (metaData: any, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/getEnabledAlarmsbyLabels/${label}?siteId=${siteId}&assetId=${assetId}&sortDirection=${SortParams}`
  interceptedAxios
    .get(url, { timeout: 25000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(error.response.data !== undefined && error.response.data !== null ? error.response.data.error_message : 'Network Error', error.response.status)
      } else {
        onFailure('Network Error', 404)
      }
    })
}
